<app-dialog
  [showHeader]="true"
  [header]="header"
  [show]="true"
  [hasControls]="true"
  [saveBtnText]="saveBtnText"
  [minWidth]="1200"
  (cancel)="canceled.emit()"
  (save)="collectFormData()">
    <div class="form">
        <app-order-form #orderForm
        [initialValue]="initialValue"
        ></app-order-form>
    </div>
</app-dialog>